<template>
  <v-text-field
    :value="value"
    :placeholder="placeholder"
    single-line
    hide-details
    dense
    outlined
    clearable
    class="search-field-compact rounded-xl"
    @input="$emit('input', $event)"
  >
    <template v-slot:prepend-inner>
      <font-awesome-icon
        :icon="['fas', 'magnifying-glass']"
        size="sm"
        class="search-icon mt-1"
      />
    </template>
  </v-text-field>
</template>

<script>
export default {
  name: 'SearchField',
  props: {
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: 'Search...',
    },
  },
}
</script>
